













import Vue from "vue";

import IconInformation from "@joyz/app-core/assets/icons/default/Information.svg";

export default Vue.extend({
  name: "DrillTips",

  data() {
    return {
      icons: {
        information: IconInformation
      }
    };
  }
});
